import { LocalizedEntranceTicketTypeBackOffice } from 'apollo/localizedTypes';
import getMissingLanguages from 'utils/i18n/getMissingLanguages';
import translatableRichText from 'utils/i18n/translatableRichText';

const dataToTable = (data: LocalizedEntranceTicketTypeBackOffice[] | undefined) => {
  if (!data) return [];
  const mappedEntrances = data?.map((entranceTicketType, index) => {
    const {
      id,
      name,
      description,
      adultValue,
      otherValue,
      maxStock,
      status,
      entranceImages,
      isBicycle,
      visibility,
    } = entranceTicketType;
    return {
      key: index,
      id,
      name: name.es,
      missingTranslations: getMissingLanguages([
        name,
        ...translatableRichText(description),
      ]),
      adultValue,
      otherValue,
      maxStock,
      status,
      entranceImages,
      isBicycle,
      visibility,
      actions: entranceTicketType,
    };
  });
  return mappedEntrances;
};

export default dataToTable;
